import { showUpgradeExternally } from "../components/UpgradePrompt";

// The one "Create a free login" box a guest sees, with a line that fits what they pressed.
// (The same box the site already uses for a locked song. Its button goes to the sign-up page.)
const LINES = {
  playlist: "Sign up free to make playlists and keep your songs.",
  skip: "Sign up free to skip to the next song or go back to the last one.",
  autoplay: "Create a free login to make playlists. Autoplay and Shuffle work inside your playlists.",
  shuffle: "Create a free login to make playlists. Autoplay and Shuffle work inside your playlists.",
  look: "Create a free login to change how the buttons look. Gold is free with a login, and Quartz is for Premium members.",
  other: "Sign up free to keep playlists and favorites.",
};

export function askForLogin(why) {
  showUpgradeExternally("Create a free login", {
    ctaLabel: "Create a free login",
    ctaPath: "/register",
    body: LINES[why] || LINES.other,
  });
}
